import { render, staticRenderFns } from "./hakAkses.vue?vue&type=template&id=d98dd828&scoped=true&"
import script from "./hakAkses.vue?vue&type=script&lang=js&"
export * from "./hakAkses.vue?vue&type=script&lang=js&"
import style0 from "./hakAkses.vue?vue&type=style&index=0&id=d98dd828&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98dd828",
  null
  
)

export default component.exports